import { Module } from 'vuex-smart-module';
import AnalyticsActions from './actions';
import AnalyticsGetters from './getters';
import AnalyticsMutations from './mutations';
import AnalyticsState from './state';

export default new Module({
  state: AnalyticsState,
  mutations: AnalyticsMutations,
  actions: AnalyticsActions,
  getters: AnalyticsGetters,
});
